import { memo } from "react";
import GoogleMapCanvas from "../../../../../commons/googleMaps/googleMapFrame/GoogleMapCanvas";
import AgenciaMarker from "./AgenciaMarker";
import DrivingRoute from "./DrivingRoute";
import MapViewport from "./MapViewport";
import RouteMarker from "./RouteMarker";

const AgenciasMapShell = memo(function AgenciasMapShell({
  apiKey,
  initialCenter,
  initialZoom,
  origenLocation,
  destinoLocation,
  origenLabel,
  destinoLabel,
  agenciaMarkers,
  viewportLocations,
  selectedId,
  onSelectAgencia,
}) {
  return (
    <GoogleMapCanvas center={initialCenter} zoom={initialZoom}>
      {origenLocation && (
        <RouteMarker
          position={origenLocation}
          title={origenLabel || "Inicio del traslado"}
          variant="origen"
        />
      )}
      {destinoLocation && (
        <RouteMarker
          position={destinoLocation}
          title={destinoLabel || "Fin del traslado"}
          variant="destino"
        />
      )}

      {agenciaMarkers.map((marker) => (
        <AgenciaMarker
          key={`agencia-${marker.id}`}
          marker={marker}
          onSelectAgencia={onSelectAgencia}
          selectedId={selectedId}
        />
      ))}

      <DrivingRoute
        apiKey={apiKey}
        destination={destinoLocation}
        origin={origenLocation}
      />

      <MapViewport locations={viewportLocations} />
    </GoogleMapCanvas>
  );
});

export default AgenciasMapShell;
